<template>
   <div>
      <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />

      <div class="auth-wrapper auth-v2">
         <div class="row auth-inner m-0">
            <div class="d-none d-lg-flex align-items-center p-5 col-lg-7" style="background-color: #f8f8f8">
               <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                  <img src="/images/reg-account.png" alt="Register V2" class="img-fluid">
               </div>
            </div>
            <div class="d-flex align-items-center auth-bg px-2 p-lg-5 col-lg-5">
               <div class="px-xl-2 mx-auto col-sm-8 col-md-6 col-lg-12">
                  <center><img src="/images/sbc-logo.png" alt="SBC logo" class="img-fluid mt-3 mt-md-0" style="height:75px;"></center>
                  <p class="font-weight-bold mb-1 fs-24 mt-4">Create a new account with us</p>
                  <div class="alert alert-danger2 alert-dismissible" role="alert" v-if="error">
                     <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=false">&times;</button>
                     <a target="#err0" hidden id="err"></a>
                     <div class="alert-body">
                        <p v-if="error_message && errors.length == 0" class="mb-0">
                           {{ error_message }}
                        </p>
                        <div v-for="(v, k) in errors" :key="k">
                           <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                        </div>
                     </div>
                  </div>

                  <div>
                     <div class="auth-register-form mt-2 mb-3 mb-md-0">
                        <div class="reg">
                           <div class="row">
                              <div class="col-md-6">
                                 <div class="form-label-group">
                                    <input id="fn" type="text" autocomplete="false" class="form-control text-uppercase" placeholder="First Name" @input="onInput($event, 'firstname')" v-model="form.firstname" :class="{'is-invalid': $v.form.firstname.$error}">
                                    <label for="fn">First Name</label>
                                 </div>
                              </div>
                              <div class=" col-md-6">
                                 <div class="form-label-group mb-0">
                                    <input id="mn" type="text" autocomplete="false" class="form-control text-uppercase" placeholder="Middle Name" @input="onInput($event, 'middlename')" v-model="form.middlename" :disabled="no_middlename" :class="{'is-invalid': $v.form.middlename.$error}">
                                    <label for="mn">Middle Name</label>
                                 </div>
                                 <div class="form-group">
                                    <div class="custom-control custom-checkbox">
                                       <input id="nm" type="checkbox" class="custom-control-input" v-model="no_middlename"
                                          @change="form.middlename = ''" />
                                       <label for="nm" class="custom-control-label">Click here if no middle name</label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div class="row">
                              <div class="col-md-6">
                                 <div class="form-label-group">
                                    <input id="ln" type="text" autocomplete="false" class="form-control text-uppercase" placeholder="Last Name" @input="onInput($event, 'lastname')" v-model="form.lastname" :class="{'is-invalid': $v.form.lastname.$error}">
                                    <label for="ln">Last Name</label>
                                 </div>
                              </div>
                              <div class=" col-md-6">
                                 <select class="custom-select dp-suffix" :style="{ color: selectColor }" @change="selectSuffix" v-model="form.suffix_code">
                                    <option value="" selected>Suffix</option>
                                    <option v-for="suffix in suffixes" :key="suffix.suffix_code" :value="suffix.suffix_code">
                                       {{ suffix.suffix_desc }}
                                    </option>
                                 </select>
                              </div>
                           </div>

                           <div>
                              <label>Date of Birth</label>
                              <div class="form-group d-flex">
                                 <select id="mm" style="width: 100%" class="custom-select" v-model="form.month"
                                    :class="{ 'is-invalid': $v.form.month.$error }" @change="updateAvailableDates()">
                                    <option value="" selected disabled>Month</option>
                                    <option v-for="(month, i) in months" :value="month.value" :key="i">
                                       {{ month.label }}
                                    </option>
                                 </select>

                                 <select id="dd" style="width: 100px" class="custom-select mx-1" v-model="form.day"
                                    :class="{ 'is-invalid': $v.form.day.$error }">
                                    <option value="" selected disabled>Day</option>
                                    <option v-for="(day, i) in days" :value="day" :key="i">
                                       {{ day }}
                                    </option>
                                 </select>

                                 <select id="yy" style="width: 110px" class="custom-select" v-model="form.year"
                                    :class="{ 'is-invalid': $v.form.year.$error }" @change="updateAvailableDates()">
                                    <option value="" selected disabled>Year</option>
                                    <option v-for="(year, i) in years" :value="year" :key="i">
                                       {{ year }}
                                    </option>
                                 </select>
                              </div>
                           </div>

                           <div class="form-label-group">
                              <input id="mobile" type="text" autocomplete="false" class="form-control" placeholder="Mobile Number" v-model="form.mobile_number"
                                 v-input-mask data-inputmask-mask="(9999) 9999999" :class="{'is-invalid': $v.form.mobile_number.$error}">
                              <label for="mobile">Mobile Number</label>
                           </div>
                           <div class="form-label-group">
                              <input id="email" type="text" autocomplete="false" class="form-control text-lowercase" placeholder="Email Address" v-model="form.email" :class="{'is-invalid': $v.form.email.$error}">
                              <label for="email">Email Address</label>
                              <span class="fs-12 text-danger" v-if="$v.form.email.$error && form.email">Please enter a valid email address</span>
                           </div>
                        </div>

                        <div>
                           <div class="input-group">
                              <input id="password" :type="showpass ? 'text': 'password'" placeholder="Password" class="form-control" v-model="form.password" autocomplete="new-password" :class="{'is-invalid': $v.form.password.$error}">
                              <div class="input-group-append">
                                 <button class="btn btn-default" @click="showpass = !showpass"><i :class="showpass ? 'fa fa-eye':'fa fa-eye-slash'"></i></button>
                              </div>
                           </div>
                           <p class="fs-15" style="margin-bottom:5px; margin-top:8px;">
                              The password must contain the following:
                           </p>
                           <div class="ml-2 mb-2 fs-12">
                              <p class="mb-0" v-for="(req, index) in password_req" :key="index">
                                 <span style="font-size:13px;" :class="{'text-success': $v.form.password[req.key] && form.password}">
                                    <feather :type="iconCheck($v.form.password[req.key] && form.password)" stroke-width="2" size="14px"></feather>&nbsp;&nbsp;{{req.label}}
                                 </span>
                              </p>
                           </div>
                        </div>

                        <button type="button" class="btn btn-success btn-block" @click="btnCreateAccount">Create Account</button>

                        <hr>
                        <p class="text-justify fs-15">
                           Small Business Corporation (SBC) respects and protects your personal data privacy.
                           To learn how SBC processes and protects confidentiality of any personal and sensitive
                           information that you may provide, please read carefully, and click the <b>"Create Account"</b>
                           button if you agree to the terms stated in <a href="pdf/SBC-Privacy-Policy-and-Notice.pdf" target="_blank">Privacy Policy.</a>
                        </p>
                        <p class="text-center">Already have an account? <a href="/login">Login instead</a></p>
                     </div>
                  </div>

               </div>
            </div>
         </div>
      </div>


      <div id="confirmation" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title">
                     For Confirmation
                  </h5>
               </div>
               <div class="modal-body">
                  <div class="alert alert-info2">
                     <p class="card-text text-justify pb-0 mb-0">Please take a moment to verify the information you've entered. Ensure all details are accurate, then confirm your account details below before submitting.</p>
                  </div>

                  <div class="reg">
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-label-group">
                              <input id="fn2" class="form-control text-uppercase" placeholder="First Name" v-model="form.firstname" disabled>
                              <label for="fn2">First Name</label>
                           </div>
                        </div>
                        <div class=" col-md-6">
                           <div class="form-label-group mb-0">
                              <input id="mn2" class="form-control text-uppercase" placeholder="Middle Name" v-model="form.middlename" disabled>
                              <label for="mn2">Middle Name</label>
                           </div>
                        </div>
                     </div>

                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-label-group">
                              <input id="ln2" class="form-control text-uppercase" placeholder="Last Name" v-model="form.lastname" disabled>
                              <label for="ln2">Last Name</label>
                           </div>
                        </div>
                        <div class=" col-md-6">
                           <select class="custom-select" v-model="form.suffix_code" disabled>
                              <option value="" selected>Suffix</option>
                              <option v-for="suffix in suffixes" :key="suffix.suffix_code" :value="suffix.suffix_code">
                                 {{ suffix.suffix_desc }}
                              </option>
                           </select>
                        </div>
                     </div>

                     <div>
                        <label>Date of Birth</label>
                        <div class="form-group d-flex">
                           <select id="mm2" style="width: 100%" class="custom-select" v-model="form.month" disabled>
                              <option value="" selected disabled>Month</option>
                              <option v-for="(month, i) in months" :value="month.value" :key="i">
                                 {{ month.label }}
                              </option>
                           </select>

                           <select id="dd2" style="width: 100px" class="custom-select mx-1" v-model="form.day" disabled>
                              <option value="" selected disabled>Day</option>
                              <option v-for="(day, i) in days" :value="day" :key="i">
                                 {{ day }}
                              </option>
                           </select>

                           <select id="yy2" style="width: 110px" class="custom-select" v-model="form.year" disabled>
                              <option value="" selected disabled>Year</option>
                              <option v-for="(year, i) in years" :value="year" :key="i">
                                 {{ year }}
                              </option>
                           </select>
                        </div>
                     </div>

                     <div class="form-label-group">
                        <input id="mobile2" class="form-control" placeholder="Mobile Number" v-model="form.mobile_number" disabled>
                        <label for="mobile2">Mobile Number</label>
                     </div>

                     <div class="form-label-group">
                        <input id="email2" class="form-control text-lowercase" placeholder="Email Address" v-model="form.email" disabled>
                        <label for="email2">Email Address</label>
                     </div>

                     <label for="pass2">Password</label>
                     <div class="input-group">
                        <input id="pass2" :type="showpass ? 'text': 'password'" placeholder="Password" class="form-control" v-model="form.password" disabled>
                        <div class="input-group-append">
                           <button class="btn btn-default" @click="showpass = !showpass"><i :class="showpass ? 'fa fa-eye':'fa fa-eye-slash'"></i></button>
                        </div>
                     </div>
                  </div>

               </div>

               <div class="modal-footer">
                  <button class="btn btn-outline-primary px-3 mr-auto" data-dismiss="modal">
                     Cancel
                  </button>
                  <button class="btn btn-primary px-3" @click="submitCreateAccount()">
                     Submit
                  </button>
               </div>

            </div>

         </div>
      </div>


      <div class="modal fade" id="reminderModal" tabindex="-1" role="dialog" data-backdrop="static">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <span class="fs-18"><b>REMINDERS:</b></span>
               </div>
               <div class="modal-body">
                  <ul>
                     <li> Please ensure that the <b>FIRST, MIDDLE and LAST NAMES, BIRTHDATE</b> are correctly
                        inputted, as no modification will be allowed once your BRS account has been created.</li>
                     <li> It should also be noted that for <b>corporations</b>, the name of the <b>President/CEO</b>
                        should be used for account creation.</li>
                     <li> The email address declared for this step will be used by SBC in officially communicating
                        with you, so please make sure that it is correct.</li>
                     <li> Kindly make the necessary corrections, if necessary. Once done, click the <b>Create
                           Account</b> button.</li>
                  </ul>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-success px-4" data-dismiss="modal">Proceed</button>
               </div>
            </div>
         </div>
      </div>


   </div>
</template>

<script>
   import {
      days,
      months,
      years
   } from "./date-array"
   import {
      required,
      minLength,
      requiredIf,
      helpers,
      email,
      sameAs
   } from "vuelidate/lib/validators";

   import VueFeather from 'vue-feather';
   Vue.use(VueFeather);

   const lower = helpers.regex('lower', /[a-z]/);
   const upper = helpers.regex('upper', /[A-Z]/);
   const num = helpers.regex('num', /\d/);
   const special = helpers.regex('special', /[!@#$%^&*_\-]/);

   export default {
      props: {
         suffixes: {
            type: Array,
            required: true
         }
      },
      data() {
         return {
            showpass: false,

            password_req: [{
                  key: 'lower',
                  label: 'at least 1 lowercase character (a-z)'
               },
               {
                  key: 'upper',
                  label: 'at least 1 uppercase character (A-Z)'
               },
               {
                  key: 'num',
                  label: 'at least 1 number (0-9)'
               },
               {
                  key: 'special',
                  label: 'at least 1 special character (!@#$%^&*_-)'
               },
               {
                  key: 'minLength',
                  label: 'at least 6 characters'
               }
            ],
            no_middlename: false,
            selectColor: '#90949c',
            days: days,
            months: months,
            years: years,

            form: {
               firstname: '',
               middlename: '',
               lastname: '',
               suffix_code: '',
               email: '',
               mobile_number: '',
               password: '',

               day: '',
               month: '',
               year: '',
               birthdate: '',
            },

            error: false,
            errors: [],
            error_message: '',
            loader: 0,
         };
      },
      computed: {
         birthdate() {
            const {
               day,
               month,
               year
            } = this.form;
            if (!day || !month || !year) {
               return "-";
            }
            return `${year}-${month}-${day}`;
         },
         processingAPI() {
            return this.loader > 0;
         },
      },
      validations: {
         form: {
            firstname: {
               required
            },
            middlename: {
               required: requiredIf(function() {
                  return !this.no_middlename;
               })
            },
            lastname: {
               required
            },
            day: {
               required
            },
            month: {
               required
            },
            year: {
               required
            },
            email: {
               required,
               email
            },
            mobile_number: {
               required
            },
            password: {
               required,
               lower,
               upper,
               num,
               special,
               minLength: minLength(6)
            },
         }
      },
      methods: {
         onInput(event, key) {
            const val = event.target.value;
            this.$set(this.form, key, val.replace(/\s{2,}/g, ' '));
         },

         selectSuffix() {
            this.selectColor = this.form.suffix_code ? '#495057' : '#90949c';
         },
         iconCheck(e) {
            return e ? 'check' : 'alert-circle';
         },

         submitCreateAccount() {
            $("#confirmation").modal("hide");
            this.apiCreateAccount();
         },
         apiCreateAccount() {
            this.loader++;
            // const formData = new FormData();
            // formData.append('firstname', this.form.firstname);
            // formData.append('middlename', this.form.middlename || 'NMN');
            // formData.append('lastname', this.form.lastname);
            // formData.append('suffix_code', this.form.suffix_code);
            // formData.append('email', this.form.email);
            // formData.append('mobile_number', this.form.mobile_number);
            // formData.append('password', this.form.password);
            // formData.append('birthdate', this.birthdate);
            this.form.birthdate = this.birthdate;
            axios
               .post("/create-account", this.form)
               .then((res) => {
                  const redirect = res.data.redirect;
                  if (redirect) {
                     this.$router.go(redirect);
                  }
               })
               .catch((err) => {
                  this.loader--;
                  this.error = 1;
                  if (err.response && err.response.data) {
                     this.errors = err.response.data.errors || [];
                     this.error_message = err.response.data.message;
                  } else {
                     this.error_message = 'Transaction Failed'
                  }
                  window.scrollTo({
                     top: 0,
                     behavior: 'smooth'
                  });
               });
         },

         btnCreateAccount() {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
               this.error_message = 'Please complete all the required fields';
               this.error = 1;
            } else {
               $("#confirmation").modal("show");
            }
         },
         updateAvailableDates() {
            const m = parseInt(this.form.month) || 1;
            const y = parseInt(this.form.year) || 2000;
            const d = parseInt(this.form.day) || 1;
            const daysInMonth = new Date(y, m, 0).getDate();
            this.days = Array.from({
               length: daysInMonth
            }, (_, i) => {
               const n = i + 1;
               return n < 10 ? "0" + n : String(n);
            });

            if (d > daysInMonth) {
               this.form.day = "";
            }
         },
      },
      mounted() {
         $("#reminderModal").modal("show");
      },
   };
</script>

<style scoped>
   .dp-suffix option:first-child {
      color: #90949c;
   }

   .dp-suffix option:not(:first-child) {
      color: #495057;
   }
</style>